function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SpinnerEl } from "common/components/spinner";
import { SvgIconEl } from "common/components/svg-icon";
import { SpinnerColor } from "../spinner/types";
import { ExperimentalTooltipEl } from "../tooltip";
import { ButtonTheme, ButtonType } from "./constants";
export function template() {
  const theme = this.attr("theme");
  const layout = this.attr("layout");
  const isPrimary = theme === ButtonTheme.Primary;
  const content = this.getContent();
  const iconOnly = this.isIconOnly();
  const isDestructive = this.attr("type") === ButtonType.Destructive || this.attr("icon") === "trashcan";
  const isPressed = this.attr("pressed");
  const isIconHighlighted = this.attr("highlight-icon");
  const isIconFilled = this.attr("fill-icon");
  const tooltip = this.params.tooltip || this.attr("tooltip");
  const displayTooltip = tooltip && !this.attr("pressed");
  const linkAttrs = _objectSpread(_objectSpread(_objectSpread({}, this.attr("href") && {
    href: this.attr("href")
  }), this.attr("target") && {
    target: this.attr("target")
  }), this.attr("download") && {
    download: this.attr("download")
  });
  return /* @__PURE__ */ jsx("a", { sel: ".mp-button-container", attrs: _objectSpread(_objectSpread({}, linkAttrs), {}, {
    elref: "buttonContainer"
  }), class: {
    ["mp-button-".concat(theme)]: true,
    ["mp-button-layout-".concat(layout)]: true,
    ["type-".concat(this.attr("type"))]: true,
    "type-destructive": isDestructive,
    "is-icon-only": iconOnly,
    "is-pressed": isPressed,
    "is-disabled": this.attr("disabled"),
    "disable-pressed-styles": this.attr("disable-pressed-styles"),
    "disabled-stays-opaque": this.attr("disabled-stays-opaque")
  }, on: {
    click: this.handleClick
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-button-animation-layer" }), /* @__PURE__ */ jsx("div", { sel: ".mp-button-content" }, this.attr("icon") === "spinner" ? /* @__PURE__ */ jsx(SpinnerEl, { key: "button-spinner", attrs: {
    color: isPrimary ? SpinnerColor.White : SpinnerColor.Blue
  } }) : this.attr("icon") ? /* @__PURE__ */ jsx(SvgIconEl, { key: "button-icon", attrs: {
    icon: this.attr("icon"),
    color: this.attr("icon-color")
  }, class: {
    highlighted: isIconHighlighted,
    filled: isIconFilled
  } }) : null, content ? /* @__PURE__ */ jsx("slot", { sel: ".mp-button-content-text" }) : null), displayTooltip && /* @__PURE__ */ jsx(ExperimentalTooltipEl, { attrs: _objectSpread({
    "delay-in": 10,
    "delay-out": 10
  }, tooltip), params: {
    text: tooltip.text
  }, props: {
    parentEl: this
  } }));
}
